"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var AdminViewDemandsPage_1 = require("../../../components/Pages/AdminPages/AdminViewDemands/AdminViewDemandsPage");
var withRouter_1 = require("../../hooks/withRouter");
var AdminDemandsPage = function (props) {
    return React.createElement(AdminViewDemandsPage_1.default, { reference: props.router.params.reference, stage: props.router.params.stage });
};
exports.default = (0, withRouter_1.default)(AdminDemandsPage);
